<template>
  <div class="row">
    <div class="col-lg-12">
      <span class="ml-3 f14 font-weight-bold">HABILIDADES TÉCNICAS</span>
      <vue-tags-input
        v-model="text"
        :disabled="!candidate_id ? true : false"
        :class="`full ${inputClasses}`"
        :tags="skills"
        @before-deleting-tag="deleteSkill"
        @before-adding-tag="createSkill"
        :autocomplete-items="autocompleteItemsSkill"
        @tags-changed="(newTags) => (skills = newTags)"
      />
      <span class="f12" v-if="candidate_id">
        PRESSIONE 'ENTER' PARA ADICIONAR AS HABILIDADES TÉCNICAS
      </span>
      <span class="f12 text-danger" v-else>
        O CANDIDATO(A) PRECISA ESTAR CRIADO PARA PODER ADICIONAR AS HABILIDADES
        TÉCNICAS
      </span>
    </div>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  props: ["candidate_id", "inputClasses"],
  components: { VueTagsInput },
  data: () => ({
    text: "",
    skills: [],
    autocompleteItemsSkill: [],
  }),
  mounted() {
    if (this.candidate_id) this.candidateSkills();
  },
  watch: {
    text: "searchSkill",
  },
  methods: {
    searchSkill() {
      if (!this.text.length) return;

      axios
        .get(`/recruiters/candidate_skills/search?term=${this.text}`)
        .then((response) => {
          this.autocompleteItemsSkill = response.data.skills;
        });
    },
    candidateSkills() {
      axios
        .get(`/recruiters/candidate_skills/${this.candidate_id}`)
        .then((response) => {
          this.skills = response.data.candidate_skills.map((skill) => ({
            id: skill.id,
            text: skill.name,
          }));
        });
    },
    deleteSkill(obj) {
      if (!obj.tag) return;

      axios
        .delete(`/recruiters/candidate_skills/${obj.tag.id}`)
        .then((response) => {
          if (response.data.status) {
            obj.deleteTag();
            return;
          }

          this.$toast.error("Não foi possivel deletar está habilidade técnica");
        });
    },
    createSkill(obj) {
      let candidate_skills = {
        candidate_id: this.candidate_id,
        name: obj.tag.text,
        skill_id: obj.tag.id,
      };

      axios
        .post("/recruiters/candidate_skills", { candidate_skills })
        .then((response) => {
          if (!response.data.id) {
            this.$toast.error(
              "Não foi possivel adicionar está habilidade técnica"
            );
            return;
          }
          obj.tag.id = response.data.id;
          obj.addTag();
        });
    },
  },
};
</script>